import { ReactComponent as Expand } from "./svg/icon-expand.svg";

export const IconExpand = () => <Expand />;
